import { Button, useDeviceType } from '@cian/ui-kit';

import { NewAnswerFooter } from '../../components/NewAnswer/parts/NewAnswerFooter';

interface INewAnswerFooterContainerProps {
  onSubmit(): void;
}

export const NewAnswerFooterContainer = ({ onSubmit }: INewAnswerFooterContainerProps) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  return (
    <NewAnswerFooter
      next={
        <Button data-testid="publish" onClick={onSubmit} fullWidth={isMobile} size={isMobile ? 'M' : 'XS'}>
          Отправить
        </Button>
      }
    />
  );
};
